import { Outlet } from "react-router-dom";

export const ReportPage = () => {
  return <Outlet />;
};
